/*  ANCHOR™ Assessment — OPTION A2 (SHOPIFY EMAIL ONLY, NO ACCOUNTS)
    - Posts to /contact (newsletter subscriber), not /account
    - Adds ONLY ONE pillar tag via contact[tags]: ANCHOR_<PILLAR>
    - Marks subscriber as accepts_marketing
    - Bot defenses: honeypot + minimum time-to-submit

    Updates:
    - Adds 1 regulated/resourced option per question (bonus scoring)
    - Awareness cannot win unless it beats 2nd place by 2
    - Tie-break priority puts Awareness last
    - Nervous System wins close ties with Choice (regulation precedes choice)

    Option 1 behavior:
    - Retakes replace the pillar (Shopify Flow removes old pillar tags)
*/

const wrapper = document.getElementById("quiz-wrapper");

if (wrapper) {
  let currentStep = 0;

  let score = {
    awareness: 0,
    nervous: 0,
    choice: 0,
    honor: 0,
    ownership: 0,
    remembrance: 0,
  };

  let quizData = [];

  // ---------- PAGE LAYOUT ----------
  wrapper.innerHTML = `
  <style>
    #quiz-wrapper .quiz-container {
      box-sizing: border-box;
      max-width: 760px;
      margin: 24px auto;
      padding: 28px 24px;
      background: #fff !important;
      background-image: none !important;
      border: 0;
      border-radius: 0 !important;
      box-shadow: none !important;
      color: #242424;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 15px;
      line-height: 1.65;
      opacity: 1 !important;
      animation: none !important;
    }
    #quiz-wrapper .quiz-container * { box-sizing: border-box; }
    #quiz-wrapper .quiz-container .intro-selector { text-align: center; margin-bottom: 0; }
    #quiz-wrapper .quiz-container .anchor-assessment-eyebrow {
      display: block;
      margin: 0 0 20px !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
      font-size: 10px !important;
      font-weight: 400 !important;
      line-height: 1.5 !important;
      letter-spacing: .22em !important;
      text-transform: uppercase !important;
      color: #595650 !important;
    }
    #quiz-wrapper .quiz-container h2,
    #quiz-wrapper .quiz-container h3,
    #quiz-wrapper .quiz-container .question-text {
      font-family: "Bodoni MT", Didot, "Times New Roman", serif !important;
      font-weight: 400 !important;
      line-height: 1.18 !important;
      letter-spacing: -.025em !important;
      text-transform: none !important;
      color: #242424 !important;
    }
    #quiz-wrapper .quiz-container .intro-selector h2 {
      max-width: 660px;
      margin: 0 auto 20px !important;
      font-size: clamp(30px, 3.5vw, 40px) !important;
      text-wrap: balance;
    }
    #quiz-wrapper .quiz-container p {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 15px !important;
      line-height: 1.65 !important;
      color: #595650;
    }
    #quiz-wrapper .quiz-container .intro-selector p {
      max-width: 620px;
      margin: 0 auto 16px !important;
    }
    #quiz-wrapper .quiz-container .anchor-assessment-truth {
      margin-top: 18px !important;
      font-family: "Bodoni MT", Didot, "Times New Roman", serif;
      font-size: 22px !important;
      font-style: italic;
    }
    #quiz-wrapper .quiz-container #startBtn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 44px;
      margin-top: 8px;
      padding: 12px 22px !important;
      border: 1px solid #282725 !important;
      border-radius: 0 !important;
      background: #282725 !important;
      color: #fff !important;
      box-shadow: none !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
      font-size: 11px !important;
      font-weight: 400 !important;
      line-height: 1.5 !important;
      letter-spacing: .12em;
      text-transform: uppercase;
      cursor: pointer;
    }
    #quiz-wrapper .quiz-container .quiz-answer {
      display: block;
      width: 100%;
      min-height: 44px;
      margin: 10px 0;
      padding: 13px 16px !important;
      border: 1px solid #bcb6ae;
      border-radius: 0 !important;
      background: #fff;
      box-shadow: none !important;
      color: #242424;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 14px !important;
      font-weight: 400;
      line-height: 1.6;
      text-align: left;
      cursor: pointer;
    }
    #quiz-wrapper .quiz-container .quiz-answer:hover {
      background: #282725;
      color: #fff;
      transform: none !important;
    }
    #quiz-wrapper .quiz-container .progress-bar {
      width: 100%; height: 4px; margin-bottom: 16px;
      background: #e6e2dc; border-radius: 0;
    }
    #quiz-wrapper .quiz-container .progress-fill {
      height: 100%; background: #282725; border-radius: 0;
    }
    #quiz-wrapper .quiz-container .progress-text {
      font-size: 11px; letter-spacing: .1em;
      color: #595650; margin-bottom: 16px; text-align: center;
    }
    #quiz-wrapper .quiz-container .question-text {
      font-size: 27px !important; margin-bottom: 22px; text-align: center;
    }
    #quiz-wrapper .quiz-container #result-title { font-size: 30px !important; }
    #quiz-wrapper .quiz-container #result-title strong { font-weight: 400; }
    #quiz-wrapper .quiz-container #email-form-container > div {
      margin-top: 22px !important;
      padding: 20px 0 !important;
      background: #fff !important;
      border-top: 1px solid #dedbd5;
      border-radius: 0 !important;
    }
    #quiz-wrapper .quiz-container #email-form-container h3 { font-size: 26px !important; }
    #quiz-wrapper .quiz-container #email-form-container a {
      border-radius: 0 !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 11px !important;
      font-weight: 400 !important;
      letter-spacing: .1em;
      text-transform: uppercase;
    }
    #quiz-wrapper .quiz-container .notice,
    #quiz-wrapper .quiz-container .status {
      max-width: 520px; margin: 14px auto 0;
      font-size: 13px; line-height: 1.6; text-align: center;
    }
    #quiz-wrapper .quiz-container :is(button,a,input):focus-visible {
      outline: 2px solid #242424; outline-offset: 4px;
    }
    #quiz-wrapper .quiz-container button::before,
    #quiz-wrapper .quiz-container button::after { border-radius: 0 !important; }
    @media(max-width: 700px) {
      #quiz-wrapper .quiz-container { margin: 16px auto; padding: 22px 18px; }
      #quiz-wrapper .quiz-container .intro-selector h2 { font-size: 30px !important; }
      #quiz-wrapper .quiz-container #startBtn { width: 100%; }
    }
</style>

<div class="quiz-container">
  <div class="intro-selector" id="intro-selector">

    <span class="anchor-assessment-eyebrow">
      The ANCHOR™ Assessment
    </span>

    <h2>
      What may be living in your blind spot?
    </h2>

    <p class="anchor-assessment-lead">
      This reflection helps you recognize the ANCHOR™ Method pillar
      most alive in your relationship with yourself today.
    </p>

    <p class="anchor-assessment-copy">
      Nothing here is a diagnosis or a verdict. It simply brings what
      may be working behind the scenes into awareness, so you can meet
      yourself with greater clarity, choice, and compassion.
    </p>

    <p class="anchor-assessment-truth">
      Once you can see it, you have a choice.
    </p>

    <button id="startBtn">
      Begin Your Reflection
    </button>

  </div>

    <div id="quiz" style="display:none;">
      <div id="question" class="question"></div>
      <div id="answers" class="answers"></div>
    </div>

    <div id="result" class="result" style="display:none; opacity:0;">
      <h2 id="result-title"></h2>
      <p id="result-description"></p>
      <div id="pillar-details"></div>
      <div id="email-form-container"></div>
      <div id="form-status" class="status" aria-live="polite"></div>
    </div>
  </div>
  `;

  // ---------- RESULTS ----------
  const results = {
    awareness: {
      title: "Awareness, The Awakening",
      description:
        "If Awareness emerged as your Anchor Point, it doesn't mean something is wrong. It means something is ready to be seen. Many women who land here are thoughtful, reflective, and insightful, yet still find themselves repeating patterns they can't quite explain. Awareness is the moment you stop living on autopilot and begin noticing what has been quietly shaping your choices, relationships, and reactions. Not to judge it. Not to fix it. Simply to see it clearly.",
    },
    nervous: {
      title: "Nervous System, The Stabilizer",
      description:
        "If Nervous System emerged as your Anchor Point, your body may be carrying more than you realize. Many women who land here appear capable, strong, and responsible. Yet beneath that strength is often a nervous system that rarely feels permission to fully rest. You may find yourself anticipating problems, preparing for outcomes, or staying alert even when there is no immediate threat. What feels like responsibility is sometimes a body that learned long ago that vigilance was safer than softness.",
    },
    choice: {
      title: "Choice, The Pivot",
      description:
        "If Choice emerged as your Anchor Point, you may already know more than you think you do. Many women who land here can sense what is true, but struggle to trust themselves enough to move. They wait for certainty, permission, perfect timing, or a sign so clear it cannot be questioned. Choice is the moment you stop waiting to feel completely ready and begin honoring the truth that is already rising inside you.",
    },
    honor: {
      title: "Honor, The Boundary",
      description:
        "If Honor emerged as your Anchor Point, there may be places in your life where you have become exceptionally good at caring for everyone except yourself. You know how to show up, support others, keep the peace, and be dependable. But this pillar asks a quieter question. Are you extending the same loyalty to yourself? Honor is where you stop abandoning yourself to be easy to love.",
    },
    ownership: {
      title: "Ownership, The Embodiment",
      description:
        "If Ownership emerged as your Anchor Point, your power may be waiting for you in the place you have been avoiding. Ownership is not blame. It is not shame. It is not making everything your fault. It is the sacred moment where you ask, what is mine to claim here? Many women who land here are ready to stop waiting for life, people, timing, or circumstances to change first. This is where the pen comes back into your hands.",
    },
    remembrance: {
      title: "Remembrance, The Homecoming",
      description:
        "If Remembrance emerged as your Anchor Point, this is not about becoming someone new. It is about returning to who you have always been beneath the roles, expectations, conditioning, proving, pleasing, and performing. Many women who land here have spent so long being who life needed them to be that they have lost touch with themselves. Remembrance is the invitation to come home to the truth that your worth was never something you had to earn.",
    },
  };

  // ---------- QUESTIONS ----------
  // "bonus: true" marks the regulated/resourced option and scores double.
  const quizDataANCHOR = [
    {
      question: "When life feels chaotic, what happens first?",
      answers: [
        { text: "I lose track of what I feel until later.", value: "awareness" },
        { text: "My body tenses and I can't exhale.", value: "nervous" },
        { text: "I freeze and struggle to make decisions.", value: "choice" },
        { text: "I say yes to keep peace even when I mean no.", value: "honor" },
        { text: "I look for someone else to fix it.", value: "ownership" },
        { text: "I forget who I am and try to become who's needed.", value: "remembrance" },
        { text: "I can pause, breathe, and come back to my body before I respond.", value: "nervous", bonus: true },
      ],
    },
    {
      question: "Which feels most familiar when you're under stress?",
      answers: [
        { text: "I disconnect or over-analyze.", value: "awareness" },
        { text: "I stay busy to avoid feeling.", value: "nervous" },
        { text: "I wait for the 'right' moment before acting.", value: "choice" },
        { text: "I over-give or apologize for needing space.", value: "honor" },
        { text: "I blame circumstances or others first.", value: "ownership" },
        { text: "I perform the version of me others expect.", value: "remembrance" },
        { text: "I can notice the stress and name what's true without spiraling.", value: "awareness", bonus: true },
      ],
    },
    {
      question: "What are you most ready to strengthen?",
      answers: [
        { text: "Seeing myself clearly.", value: "awareness" },
        { text: "Feeling safe in my body.", value: "nervous" },
        { text: "Making aligned decisions quickly.", value: "choice" },
        { text: "Holding boundaries without guilt.", value: "honor" },
        { text: "Taking full responsibility for my energy.", value: "ownership" },
        { text: "Living from wholeness, not proving.", value: "remembrance" },
        { text: "I can hold my truth and take the next right step, even if it's small.", value: "choice", bonus: true },
      ],
    },
    {
      question: "What often pulls you off-center?",
      answers: [
        { text: "Not understanding why I feel what I feel.", value: "awareness" },
        { text: "Anxiety that comes from nowhere.", value: "nervous" },
        { text: "Indecision or people-pleasing.", value: "choice" },
        { text: "Fear of disappointing someone.", value: "honor" },
        { text: "Waiting for life to change first.", value: "ownership" },
        { text: "Forgetting what lights me up.", value: "remembrance" },
        { text: "I can stay with myself, even when someone else is disappointed.", value: "honor", bonus: true },
      ],
    },
    {
      question: "When you imagine your next chapter, what do you crave most?",
      answers: [
        { text: "Clarity and self-honesty.", value: "awareness" },
        { text: "Peace that lasts.", value: "nervous" },
        { text: "Confidence in my choices.", value: "choice" },
        { text: "Relationships that honor mutual respect.", value: "honor" },
        { text: "Empowered responsibility.", value: "ownership" },
        { text: "A deep sense of coming home to myself.", value: "remembrance" },
        { text: "I can lead myself without waiting for permission.", value: "ownership", bonus: true },
      ],
    },
    {
      question: "When someone asks 'How are you?' and you're not okay...",
      answers: [
        { text: "I say 'fine' before I even know what's true.", value: "awareness" },
        { text: "I feel my body tense but don't know why.", value: "nervous" },
        { text: "I pause but struggle to find the words.", value: "choice" },
        { text: "I smile to keep them from worrying.", value: "honor" },
        { text: "I deflect and ask about them instead.", value: "ownership" },
        { text: "I perform the version they expect to see.", value: "remembrance" },
        { text: "I can be honest in a grounded way without over-explaining.", value: "honor", bonus: true },
      ],
    },
    {
      question: "How often do you check in with yourself about what you're actually feeling?",
      answers: [
        { text: "Multiple times a day, it's my practice.", value: "awareness" },
        { text: "When something feels physically off.", value: "nervous" },
        { text: "When I need to make a decision.", value: "choice" },
        { text: "When I'm about to abandon myself.", value: "honor" },
        { text: "When I'm blaming someone else.", value: "ownership" },
        { text: "When I've lost sight of who I am.", value: "remembrance" },
        { text: "I can check in and actually listen to what I find.", value: "awareness", bonus: true },
      ],
    },
    {
      question: "When you notice you're stressed, anxious, or overwhelmed...",
      answers: [
        { text: "I can name exactly what triggered it.", value: "awareness" },
        { text: "I feel it in my body but can't name it.", value: "nervous" },
        { text: "I freeze and don't know what to do.", value: "choice" },
        { text: "I immediately people-please to fix it.", value: "honor" },
        { text: "I look outside myself for the cause.", value: "ownership" },
        { text: "I forget what brings me peace.", value: "remembrance" },
        { text: "I can bring myself back to center before I act.", value: "nervous", bonus: true },
      ],
    },
    {
      question: "How would you describe your relationship with truth (what's actually happening)?",
      answers: [
        { text: "I see it clearly and name it.", value: "awareness" },
        { text: "I feel it but struggle to trust it.", value: "nervous" },
        { text: "I see it but don't always act on it.", value: "choice" },
        { text: "I know it but soften it for others.", value: "honor" },
        { text: "I wait for others to name it first.", value: "ownership" },
        { text: "I've lost touch with what's true for me.", value: "remembrance" },
        { text: "I can stay honest without collapsing or performing.", value: "remembrance", bonus: true },
      ],
    },
    {
      question: "When you're moving through your day on autopilot...",
      answers: [
        { text: "I catch myself and check in.", value: "awareness" },
        { text: "My body signals me to slow down.", value: "nervous" },
        { text: "I notice but keep moving anyway.", value: "choice" },
        { text: "I realize I've said yes to too much.", value: "honor" },
        { text: "I blame my schedule or circumstances.", value: "ownership" },
        { text: "I don't even notice until the day is over.", value: "remembrance" },
        { text: "I can interrupt autopilot and choose presence on purpose.", value: "choice", bonus: true },
      ],
    },
    {
      question: "How does your body feel most of the time?",
      answers: [
        { text: "I'm not sure, I don't pay attention.", value: "awareness" },
        { text: "Tense, braced, on edge.", value: "nervous" },
        { text: "Heavy with decisions I haven't made.", value: "choice" },
        { text: "Tight from holding too much.", value: "honor" },
        { text: "Exhausted from trying to control everything.", value: "ownership" },
        { text: "Disconnected, I don't recognize it anymore.", value: "remembrance" },
        { text: "Steady enough to breathe, feel, and respond without rushing.", value: "nervous", bonus: true },
      ],
    },
    {
      question: "When stress hits, your first physical response is:",
      answers: [
        { text: "I go numb or disconnect mentally.", value: "awareness" },
        { text: "My heart races or I can't breathe.", value: "nervous" },
        { text: "I freeze completely.", value: "choice" },
        { text: "I immediately scan who needs me.", value: "honor" },
        { text: "I tense up and power through.", value: "ownership" },
        { text: "I shrink and become invisible.", value: "remembrance" },
        { text: "I can soften my body and stay present with what is.", value: "nervous", bonus: true },
      ],
    },
    {
      question: "How often do you practice regulating your nervous system?",
      answers: [
        { text: "I don't know how to tell if I'm regulated.", value: "awareness" },
        { text: "I try but it never seems to stick.", value: "nervous" },
        { text: "Only when I'm already dysregulated.", value: "choice" },
        { text: "When I feel guilty for taking time for myself.", value: "honor" },
        { text: "I expect myself to handle it without help.", value: "ownership" },
        { text: "I've forgotten how to feel safe.", value: "remembrance" },
        { text: "I can regulate in small moments before stress becomes a spiral.", value: "nervous", bonus: true },
      ],
    },
    {
      question: "When you're dysregulated, can you bring yourself back to calm?",
      answers: [
        { text: "I don't always realize I'm dysregulated.", value: "awareness" },
        { text: "No, I feel trapped in it.", value: "nervous" },
        { text: "I know I should but I don't.", value: "choice" },
        { text: "Only if I'm alone, not around others.", value: "honor" },
        { text: "I wait for circumstances to change first.", value: "ownership" },
        { text: "I've forgotten what calm feels like.", value: "remembrance" },
        { text: "Yes, I can return to center without needing the world to change first.", value: "ownership", bonus: true },
      ],
    },
    {
      question: "Your jaw, shoulders, and breath right now are:",
      answers: [
        { text: "I wasn't paying attention until now.", value: "awareness" },
        { text: "Clenched, tight, shallow.", value: "nervous" },
        { text: "Tense because I'm avoiding something.", value: "choice" },
        { text: "Holding because I can't say no.", value: "honor" },
        { text: "Braced because life feels out of control.", value: "ownership" },
        { text: "Numb, I can't feel them.", value: "remembrance" },
        { text: "Soft enough to breathe fully and stay here with myself.", value: "nervous", bonus: true },
      ],
    },
    {
      question: "When faced with a decision, you:",
      answers: [
        { text: "Overthink until I can't see clearly.", value: "awareness" },
        { text: "Feel panic and want to avoid it.", value: "nervous" },
        { text: "Freeze and wait for the 'right' answer.", value: "choice" },
        { text: "Choose what keeps everyone happy.", value: "honor" },
        { text: "Wait for someone else to decide.", value: "ownership" },
        { text: "Choose what I 'should' do, not what I want.", value: "remembrance" },
        { text: "I can pause, feel what's true, and decide from alignment.", value: "choice", bonus: true },
      ],
    },
    {
      question: "How often do you say 'yes' when you mean 'no'?",
      answers: [
        { text: "I don't always know what I mean.", value: "awareness" },
        { text: "All the time, my body says no, my mouth says yes.", value: "nervous" },
        { text: "Constantly, I can't seem to stop.", value: "choice" },
        { text: "Every time I'm afraid to disappoint someone.", value: "honor" },
        { text: "When I don't want to take responsibility for the outcome.", value: "ownership" },
        { text: "Whenever I forget I'm allowed to choose.", value: "remembrance" },
        { text: "I can say no cleanly and stay steady in my body.", value: "honor", bonus: true },
      ],
    },
    {
      question: "When you make a choice that honors you, how do you feel afterward?",
      answers: [
        { text: "Unsure if I made the right call.", value: "awareness" },
        { text: "Anxious, my body won't settle.", value: "nervous" },
        { text: "Guilty or worried I was selfish.", value: "choice" },
        { text: "Scared they'll punish me for it.", value: "honor" },
        { text: "Defensive, like I need to justify it.", value: "ownership" },
        { text: "Like I've betrayed who I 'should' be.", value: "remembrance" },
        { text: "Proud and grounded, like my inner world just got quieter.", value: "honor", bonus: true },
      ],
    },
    {
      question: "How would you describe your relationship with choice?",
      answers: [
        { text: "I'm not sure I trust my own judgment.", value: "awareness" },
        { text: "My body hijacks my choices.", value: "nervous" },
        { text: "I feel stuck in old patterns.", value: "choice" },
        { text: "I give my power away to avoid conflict.", value: "honor" },
        { text: "I wait for life to choose for me.", value: "ownership" },
        { text: "I choose what's expected, not what's true.", value: "remembrance" },
        { text: "I can choose from self-trust, even when it's uncomfortable.", value: "choice", bonus: true },
      ],
    },
    {
      question: "The pause between trigger and response:",
      answers: [
        { text: "I don't notice it until after I've reacted.", value: "awareness" },
        { text: "My body reacts before I can think.", value: "nervous" },
        { text: "I see it but can't access it.", value: "choice" },
        { text: "I collapse in it instead of using it.", value: "honor" },
        { text: "I blame the trigger instead of choosing differently.", value: "ownership" },
        { text: "I don't believe I deserve to use it.", value: "remembrance" },
        { text: "I can access the pause and choose my response on purpose.", value: "choice", bonus: true },
      ],
    },
    {
      question: "How do you feel about setting boundaries?",
      answers: [
        { text: "I'm not sure where mine are.", value: "awareness" },
        { text: "Terrified, my body won't let me.", value: "nervous" },
        { text: "I know I should but I don't.", value: "choice" },
        { text: "Guilty, like I'm being selfish.", value: "honor" },
        { text: "Resentful that I have to.", value: "ownership" },
        { text: "Unworthy, like I don't deserve them.", value: "remembrance" },
        { text: "I can set a boundary and stay rooted in my truth.", value: "honor", bonus: true },
      ],
    },
    {
      question: "When someone crosses a boundary you've set:",
      answers: [
        { text: "I don't always notice until later.", value: "awareness" },
        { text: "I feel it physically but freeze.", value: "nervous" },
        { text: "I see it but don't know what to do.", value: "choice" },
        { text: "I soften it immediately to keep peace.", value: "honor" },
        { text: "I blame myself for not being clearer.", value: "ownership" },
        { text: "I question if I deserved better anyway.", value: "remembrance" },
        { text: "I can restate the boundary without apologizing or escalating.", value: "honor", bonus: true },
      ],
    },
    {
      question: "How often do you abandon yourself to keep others comfortable?",
      answers: [
        { text: "I don't always realize I'm doing it.", value: "awareness" },
        { text: "Constantly, it's my default survival response.", value: "nervous" },
        { text: "Every time I have a choice between me and them.", value: "choice" },
        { text: "It's automatic, I don't even think about it.", value: "honor" },
        { text: "I tell myself I'm choosing it, but I'm not.", value: "ownership" },
        { text: "Always, their comfort matters more than mine.", value: "remembrance" },
        { text: "I can stay connected to myself even when others are uncomfortable.", value: "remembrance", bonus: true },
      ],
    },
    {
      question: "Your relationship with the word 'no':",
      answers: [
        { text: "I'm not sure when it's okay to use it.", value: "awareness" },
        { text: "My body panics when I try to say it.", value: "nervous" },
        { text: "I think it but can't say it.", value: "choice" },
        { text: "I say it but don't hold it.", value: "honor" },
        { text: "I expect myself to handle everything without it.", value: "ownership" },
        { text: "I don't feel worthy of using it.", value: "remembrance" },
        { text: "I can say no and trust myself afterward.", value: "remembrance", bonus: true },
      ],
    },
    {
      question: "When you honor yourself and someone is disappointed:",
      answers: [
        { text: "I second-guess whether I was right.", value: "awareness" },
        { text: "I feel it in my chest and want to take it back.", value: "nervous" },
        { text: "I immediately regret the choice.", value: "choice" },
        { text: "I cave and apologize.", value: "honor" },
        { text: "I defend myself instead of staying grounded.", value: "ownership" },
        { text: "I feel like I've failed them.", value: "remembrance" },
        { text: "I can stay steady, kind, and unwavering.", value: "honor", bonus: true },
      ],
    },
    {
      question: "When something goes wrong in your life:",
      answers: [
        { text: "I analyze it but don't see my role.", value: "awareness" },
        { text: "I feel overwhelmed and shut down.", value: "nervous" },
        { text: "I know I should take action but don't.", value: "choice" },
        { text: "I over-function and take on everyone's part.", value: "honor" },
        { text: "I blame circumstances or others first.", value: "ownership" },
        { text: "I feel like life is happening to me.", value: "remembrance" },
        { text: "I can ask, what's mine to own here, and take the next step.", value: "ownership", bonus: true },
      ],
    },
    {
      question: "How do you respond to feedback or criticism?",
      answers: [
        { text: "I don't know if it's true or not.", value: "awareness" },
        { text: "I feel attacked and go into defense.", value: "nervous" },
        { text: "I freeze and can't respond.", value: "choice" },
        { text: "I apologize even if I don't agree.", value: "honor" },
        { text: "I reject it completely.", value: "ownership" },
        { text: "I collapse into 'I'm not good enough.'", value: "remembrance" },
        { text: "I can stay grounded, consider it, and keep my self-worth intact.", value: "remembrance", bonus: true },
      ],
    },
    {
      question: "When you're stuck in a pattern, you:",
      answers: [
        { text: "Don't realize I'm in one until it's too late.", value: "awareness" },
        { text: "Feel trapped and powerless.", value: "nervous" },
        { text: "See it but don't know how to change it.", value: "choice" },
        { text: "Keep giving to avoid facing it.", value: "honor" },
        { text: "Wait for others or circumstances to change first.", value: "ownership" },
        { text: "Believe this is just who I am.", value: "remembrance" },
        { text: "I can see the pattern and choose one new response to interrupt it.", value: "choice", bonus: true },
      ],
    },
    {
      question: "How do you hold the pen in your own story?",
      answers: [
        { text: "I don't see myself as the main character.", value: "awareness" },
        { text: "I feel like I'm being written by fear.", value: "nervous" },
        { text: "I hold it but don't know what to write.", value: "choice" },
        { text: "I give it away to keep others happy.", value: "honor" },
        { text: "Someone else is holding it.", value: "ownership" },
        { text: "I don't believe I'm worthy of writing it.", value: "remembrance" },
        { text: "I can claim authorship without waiting to feel perfect.", value: "ownership", bonus: true },
      ],
    },
    {
      question: "When you mess up:",
      answers: [
        { text: "I don't always see it clearly.", value: "awareness" },
        { text: "I spiral into anxiety and shame.", value: "nervous" },
        { text: "I see it but avoid addressing it.", value: "choice" },
        { text: "I over-apologize to fix it quickly.", value: "honor" },
        { text: "I defend or justify instead of owning it.", value: "ownership" },
        { text: "I collapse into 'I'm broken.'", value: "remembrance" },
        { text: "I can repair without shaming myself, and return to truth.", value: "ownership", bonus: true },
      ],
    },
  ];

  // ---------- START QUIZ ----------
  document.addEventListener("click", function (e) {
    if (e.target && e.target.id === "startBtn") {
      quizData = quizDataANCHOR;
      currentStep = 0;
      for (let key in score) score[key] = 0;
      document.getElementById("intro-selector").style.display = "none";
      document.getElementById("quiz").style.display = "block";
      renderQuestion();
    }
  });

  function renderQuestion() {
    const q = quizData[currentStep];
    const qEl = document.getElementById("question");
    const aEl = document.getElementById("answers");

    const progress = Math.round(((currentStep + 1) / quizData.length) * 100);

    qEl.innerHTML = `
      <div class="progress-bar">
        <div class="progress-fill" style="width:${progress}%;"></div>
      </div>
      <p class="progress-text">Question ${currentStep + 1} of ${quizData.length}</p>
      <h3 class="question-text">${q.question}</h3>
    `;

    aEl.innerHTML = "";

    q.answers.forEach((ans) => {
      const btn = document.createElement("button");
      btn.innerText = ans.text;
      btn.classList.add("quiz-answer");
      btn.onclick = () => {
        score[ans.value] += 1;
        if (ans.bonus === true) score[ans.value] += 1;

        currentStep++;
        if (currentStep < quizData.length) renderQuestion();
        else showResult();
      };
      aEl.appendChild(btn);
    });
  }

  // ---------- SHOW RESULT + EXPLORE BOOK ----------
  function showResult() {
    const quizEl = document.getElementById("quiz");
    const resultEl = document.getElementById("result");
    const titleEl = document.getElementById("result-title");
    const descEl = document.getElementById("result-description");
    const pillarDetails = document.getElementById("pillar-details");
    const formContainer = document.getElementById("email-form-container");
    const statusEl = document.getElementById("form-status");

    quizEl.style.opacity = "0";
    setTimeout(() => {
      quizEl.style.display = "none";
      resultEl.style.display = "block";
      setTimeout(() => (resultEl.style.opacity = "1"), 50);
    }, 400);

    // Sort scores
    const entries = Object.entries(score).sort((a, b) => b[1] - a[1]);
    const [firstKey, firstVal] = entries[0];
    const [secondKey, secondVal] = entries[1] || [firstKey, firstVal];

    let topResult = firstKey;

    // Rule 1: Awareness must win by 2 to take the crown
    if (firstKey === "awareness" && firstVal - secondVal < 2) {
      topResult = secondKey;
    }

    // Rule 2: Nervous wins close ties with Choice
    if (
      (firstKey === "choice" && secondKey === "nervous") ||
      (firstKey === "nervous" && secondKey === "choice")
    ) {
      if (Math.abs(firstVal - secondVal) <= 1) {
        topResult = "nervous";
      }
    }

    // Rule 3: Tie-break priority
    const priority = ["nervous", "choice", "honor", "ownership", "remembrance", "awareness"];
    const topScore = entries[0][1];
    const tied = entries.filter((e) => e[1] === topScore);

    if (tied.length > 1) {
      for (let p of priority) {
        if (tied.find((t) => t[0] === p)) {
          topResult = p;
          break;
        }
      }
    }

    const result = results[topResult];

    titleEl.innerHTML = `<strong>Your Anchor Point:</strong> ${result.title}`;
    descEl.innerText = result.description;

    pillarDetails.innerHTML = `
      <p style="font-style:italic;margin:1rem 0;line-height:1.6;">
        This result isn't a label. It's an invitation to notice where your growth is asking for attention right now. Every pillar matters. This one simply appears to be calling you first.
      </p>
    `;

    if (formContainer) {
      formContainer.innerHTML = `
        <div style="margin-top:2rem;padding:1.75rem;background:#f8f7f5;border-radius:12px;text-align:center;">
          <h3 style="margin-top:0;margin-bottom:1rem;">
            Explore the Complete Method
          </h3>

          <p style="line-height:1.7;margin-bottom:1rem;">
            Your Anchor Point reveals where your journey may begin.
          </p>

          <p style="line-height:1.7;margin-bottom:1.5rem;">
            <em>You Are The Anchor</em> reveals how all six pillars work together.
          </p>

          <a href="/pages/you-are-the-anchor-book"
             style="
               display:inline-block;
               background:#000;
               color:#fff;
               text-decoration:none;
               padding:14px 28px;
               border-radius:999px;
               font-weight:600;
             ">
            Explore the Book
          </a>
        </div>
      `;
    }

    if (statusEl) {
      statusEl.textContent = "";
    }

    // Bot defenses on submit
    const form = document.getElementById("anchorEmailForm");

    form.addEventListener("submit", function (e) {
      statusEl.textContent = "";

      // Honeypot check
      const hp = form.querySelector('input[name="website"]');
      if (hp && hp.value.trim() !== "") {
        e.preventDefault();
        statusEl.textContent = "Something went wrong. Please refresh and try again.";
        return;
      }

      // Minimum time check (3 seconds)
      const started = parseInt(form.querySelector("#started_at")?.value || "0", 10);
      const elapsed = Date.now() - started;

      if (!started || elapsed < 3000) {
        e.preventDefault();
        statusEl.textContent = "Please take a breath, then try again.";
        return;
      }

      statusEl.textContent = "Sending...";
    });
  }
}

